import { createSlice } from "@reduxjs/toolkit";



// ------------------------------------------ Functions

// ...



// ------------------------------------------ Slice

// createSlice permet de fusionner action et reducer (modifie store)
export const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    companyConfigData: {},
    companyWaConfigData: {}
    // vipsData: {}
  },
  reducers: {
    setCompanyConfigData: (state, { payload }) => {
      state.companyConfigData = payload;
    },
    setCompanyWaConfigData: (state, { payload }) => {
      state.companyWaConfigData = payload;
    }
    // setVipsData: (state, { payload }) => {
    //   console.log('payload: ', payload)
    //   state.vipsData = payload;
    //   // let googleArray = [];
    //   // for (let i = 0; i < payload.length; i++) {
    //   //   const arr = [...payload];
    //   //   if (!arr[i].state) arr[i].state = undefined;
    //   //   if (payload[i].type === "google") {
    //   //     googleArray.push(payload[i])
    //   //   }
    //   // }
    //   // state.googleDrives = googleArray;
    // },
  },
});



// ------------------------------------------ Export

// On a l'action et le reducer au meme endroit
export const { setCompanyConfigData, setCompanyWaConfigData } = settingsSlice.actions;
export default settingsSlice.reducer;
